import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { NavigationEnd, Router, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'df-base-nav-link',
  templateUrl: './base-nav-link.component.html',
  styleUrls: ['./base-nav-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseNavLinkComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();

  @Input() iconSrc = '';
  @Input() name = '';
  @Input() routerLinkUrl: string | string[] = '';
  @Input() href = '';
  @Input() matchActiveClass: string[] = [];
  @Input() skipLocationChange = false;
  @Input() notificationsCount = '';
  @Input() dropdownIcon = false;

  @ViewChild('link') link!: RouterLinkActive;

  constructor(
    public basePanelService: BasePanelService,
    private router: Router,
    private changes: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.listenRouterChange();
    this.listenShortNavChange();
  }

  listenShortNavChange() {
    const sub = this.basePanelService.emitter.subscribe(() => {
      this.changes.detectChanges();
    });
    this.sub.add(sub);
  }

  listenRouterChange() {
    const sub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.changes.detectChanges();
    });
    this.sub.add(sub);
  }

  isMatchActiveClass() {
    if (!this.matchActiveClass.length) return false;
    const notMatched = this.matchActiveClass.filter((url) => (window.location.href.indexOf(url) !== -1 ? false : true));
    return !notMatched.length;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
